// The text block shown below the role card on the reveal. Extracted so the
// real reveal (RoleReveal) and the dev card gallery (CardGallery) render the
// exact same thing and can't drift. Surfaces the three pieces a first-timer
// needs and previously never saw: the plain role NAME (independent of the
// stylised card art), their SIDE, and their WIN CONDITION — derived from the
// shared goal layer (audit theme 1 / bigger bet #1) — plus the ability prose
// and, for mafia, their known teammates.

import type { Lang, RoleConfig } from '../../../shared/src/types.js';
import { goalForRole, GOAL_LABEL } from '../../../shared/src/goals.js';

interface Props {
  role: RoleConfig;
  t: Lang;
  /** Resolved ally display names. Omit/empty for no team block. */
  allies?: string[];
}

export function RoleRevealInfo({ role, t, allies }: Props) {
  const goal = goalForRole(role, t);
  return (
    <div className="reveal-info">
      <div className="reveal-info-name display" style={{ color: role.accent }}>
        {role.title[t]}
      </div>
      <div className="reveal-info-side mono">
        {t === 'ru' ? 'СТОРОНА' : 'СТОРОНА'} · {goal.sideLabel}
      </div>

      <div className="reveal-info-title sub" style={{ color: role.accent }}>
        {GOAL_LABEL[t]}
      </div>
      <p className="reveal-info-text reveal-info-goal">{goal.how}</p>

      <div className="reveal-info-title sub" style={{ color: role.accent, marginTop: 10 }}>
        {t === 'ru' ? 'СПОСОБНОСТЬ' : 'ЗДІБНІСТЬ'}
      </div>
      <p className="reveal-info-text">{role.ability[t]}</p>

      {allies && allies.length > 0 && (
        <>
          <div
            className="reveal-info-title sub"
            style={{ color: 'var(--poison-red)', marginTop: 10 }}
          >
            {t === 'ru' ? 'ВАША КОМАНДА' : 'ВАША КОМАНДА'}
          </div>
          <div className="reveal-allies">
            {allies.map((nm, i) => (
              <span key={i} className="reveal-ally display">
                {nm}
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
